import { useEffect, useState } from "react";
import { ClipboardEdit, Loader2, Save } from "lucide-react";
import { anafPublic, errText, fetchPublicForm, savePublicForm, uploadCiLink } from "@/lib/bf";
import BFContractFields from "./BFContractFields";

export default function BFPublicForm({ t, draft, onSaved }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [ciErr, setCiErr] = useState([]);
  const [open, setOpen] = useState(draft);
  useEffect(() => { fetchPublicForm(t).then((r) => setD(r.data)).catch(() => setD(false)); }, [t]);
  if (d === false) return null;
  if (!open) return <button type="button" className="st-btn st-btn--ghost" onClick={() => setOpen(true)} data-testid="bf-pub-form-open"><ClipboardEdit size={14} /> Modifică datele firmei și ale garanților</button>;
  if (!d) return <p className="bf-gate-sub"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p>;
  const save = () => {
    setBusy(true); setMsg("");
    const body = { ...d, fid: (d.fid || []).map((g) => (g.admin ? { ...g, nume: d.admin } : g)) };
    savePublicForm(t, body).then(() => { setCiErr([]); setOpen(false); onSaved(); })
      .catch((e) => { const det = e?.response?.data?.detail; if (det?.ci) { setCiErr(det.ci); setMsg(det.msg); } else if (det?.anaf) setMsg(det.msg); else setMsg(errText(e, "Completați câmpurile cu * (CNP de 13 cifre, telefon și e-mail pentru garanți, cod poștal de 6 cifre).")); })
      .finally(() => setBusy(false));
  };
  return (
    <div className="bf-sign-firm bf-pub-form" data-testid="bf-pub-form">
      <div className="bf-sign-head"><b><ClipboardEdit size={15} /> Datele firmei și ale garanților</b></div>
      <p className="bf-gate-sub">Completați datele de mai jos. Cu „Caută la ANAF” se completează singure numele firmei, sediul și Reg. Com. După salvare puteți semna imediat. Agentul verifică datele.</p>
      <BFContractFields d={d} setD={setD} reader={(img, part) => uploadCiLink(t, img, part)} anaf={(cui) => anafPublic(t, cui)} ciErr={ciErr} />
      {msg && <p className="bf-lead-err" data-testid="bf-pub-form-error">{msg}</p>}
      <button type="button" className="st-btn st-btn--silver" onClick={save} disabled={busy} data-testid="bf-pub-form-save">{busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Salvează datele și treci la semnare</button>
    </div>
  );
}
